import React from 'react'
import {
  Stack,
  Box,
  Paper,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ApartmentTypeFragmentFragment } from 'api/generated'
import RemoteImage from '../RemoteImage'
import { ApartmentTypeMetadataType } from 'schemas/apartmentType'

type ApartmentTypeDetailPanelProps = {
  data: ApartmentTypeFragmentFragment
}

const ApartmentTypeDetailPanel: React.FC<ApartmentTypeDetailPanelProps> = ({
  data
}: ApartmentTypeDetailPanelProps) => {
  const { t } = useTranslation()
  const photos = data?.photos
  const metadata = data?.metadata as ApartmentTypeMetadataType
  const amenities = metadata?.amenities

  return (
    <Box p={2} height='100%'>
      <Paper sx={{ height: '100%' }}>
        <Stack spacing={2} p={2} divider={<Divider />}>
          <Stack>
            <Typography variant='h5'>{t('images')}</Typography>
            <Stack spacing={2} direction='row'>
              {photos?.map(photo => {
                const path = photo?.path
                return <RemoteImage key={photo?.id} filePath={path} />
              })}
            </Stack>
          </Stack>

          <Stack>
            <Typography variant='h5'>{t('amenities')}</Typography>
            <List
              sx={{
                overflow: 'auto',
                maxHeight: 200
              }}
            >
              {amenities.map(amenity => (
                <ListItem key={amenity?.value}>
                  <ListItemText primary={amenity?.value} />
                </ListItem>
              ))}
            </List>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  )
}

export default ApartmentTypeDetailPanel
